import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAdminPositions, getPositionAvailableColumns, getPositionRoleCategories, getWorkTypes } from './api';

export const path = '/position/list';

const PagePositionList: React.FC = (props) => {
  const PositionList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getPositionAvailableColumns,
      workTypes: getWorkTypes,
      adminPositions: getAdminPositions,
      positionRoleCategories: getPositionRoleCategories,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <PositionList {...props} />;
};

export default PagePositionList;
